import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface DashboardStatCardProps {
  value: number | string;
  label: string;
  icon?: ReactNode;
  bgColor?: string;
  accentColor?: string;
  isActive?: boolean;
  fetchData: () => Promise<void>;
}

export function DashboardStatCard({
  value,
  label,
  icon,
  bgColor = "#def2f2",
  accentColor = "#08c270",
  isActive = false,
  fetchData,
}: DashboardStatCardProps) {
  return (
    <Box
      width="100%"
      onClick={fetchData}
      maxHeight={120}
      borderRadius={2}
      alignContent={"center"}
      alignItems={"center"}
      p={4}
      bgcolor={bgColor}
      sx={{
        cursor: "pointer",
        transition: "all 0.3s ease",
        outline: isActive ? `2.5px solid ${accentColor}` : "2.5px solid transparent",
        boxShadow: isActive ? `0 6px 20px ${accentColor}40` : "0 0 0 rgba(0,0,0,0)",
        transform: isActive ? "translateY(-4px)" : "translateY(0)",

        "&:hover": {
          boxShadow: `0 12px 30px rgba(0,0,0,0.15)`,
          transform: "translateY(-6px)",
        },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" flexDirection="column">
          <Typography fontWeight={700} fontSize={28} color={accentColor}>
            {value}
          </Typography>

          <Typography fontWeight={600} color={accentColor}>
            {label}
          </Typography>
        </Box>

        {icon && (
          <Box
            width={70}
            height={70}
            borderRadius={3}
            bgcolor={accentColor}
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="#fff"
          >
            {icon}
          </Box>
        )}
      </Stack>
    </Box>
  );
}
